import LogoutTemplate from '../../templates/settings/ui/logout';

export default function LogoutPage() {
  return <LogoutTemplate />;
}
